module.exports = __webpack_public_path__ + "static/assets/c30c74cb604e0e98aa72758f31629244.png";